import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { forgotPassword, login } from "../api";
import useValidations from "../../../utils/hooks/useValidations";
import useRoutes from "../../../routes/useRoutes";
import { useDispatch } from "react-redux";
import { getMenuPermissions, updateConfig } from "../../../store/slices/Global";

const useAuth = (emailRef) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { validateEmail } = useValidations();

  const [loginStatus, setLoginStatus] = useState("idle");
  const [loginInfo, setLoginInfo] = useState({});
  const [showPassword, setShowPassword] = useState(true);
  const [forgotPasswordStatus, setForgotPasswordStatus] = useState("idle");
  const [forgotPasswordInfo, setForgotPasswordInfo] = useState({});

  const userToken = localStorage.getItem("USER_ACCESS_TOKEN");
  const { allowedUserComponent } = useRoutes();

  useEffect(() => {
    if (loginStatus === "success") {
      dispatch(
        updateConfig((state) => {
          state.isLogged = true;
        })
      );
      navigate(
        `/`
      );
      // window.location.reload();
    } else if (loginStatus === "failed") {
      let errorFields = Object.keys(loginInfo);
      errorFields.forEach((field) => {
        formik.setFieldError(field, loginInfo[field]);
      });
    }
    // eslint-disable-next-line
  }, [loginStatus,allowedUserComponent]);

  // useEffect(() => {
  //   if (userToken != undefined) {
  //     navigate("/customers");
  //   }
  //   // eslint-disable-next-line
  // }, [userToken]);

  useEffect(() => {
    if (forgotPasswordStatus === "success") {
      navigate(`/login/forgot-password/${forgotPasswordInfo.token}`);
    } else if (forgotPasswordStatus === "failed") {
      let errorFields = Object.keys(forgotPasswordInfo);
      errorFields.forEach((field) => {
        formik.setFieldError(field, forgotPasswordInfo[field]);
      });
    }
    // eslint-disable-next-line
  }, [forgotPasswordStatus]);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validate: (values) => {
      let errors = {};
      if (!values.email) {
        errors.email = "*Email Required";
      }
      if (!values.password) {
        errors.password = "*Password Required";
      }
      if(values.email) {
        if (!validateEmail(values.email)) {
          errors.email = "*Enter a valid email";
        }
      }
      
      return errors;
    },
    onSubmit: (values) => {
      emailRef.current = values.email;

      setLoginStatus("pending");

      login(values).then((response) => {
        if (response.data.success) {
          setLoginInfo(response?.data?.data);
          localStorage.setItem("user_role", response?.data?.data?.user_role);
          localStorage.setItem(
            "USER_ACCESS_TOKEN",
            response?.data?.data?.token
          );
          setLoginStatus("success");
          
        } else {
          if (response?.message !== "") {
            setLoginStatus("failed");
            setLoginInfo({
              password: response?.message,
            });
          } else {
            setLoginStatus("failed");
            setLoginInfo({
              password:
                "An error occurred during login. Please try again later.",
            });
          }
        }
      });
    },
  });

  const handleForgotPassword = () => {
    navigate(`/login/forgot-password`);
  };

  const handleShowPassword = (e) => {
    e.preventDefault();

    setShowPassword(!showPassword);
    var x = document.getElementById("password");
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  };

  return {
    formik,
    loginStatus,
    forgotPasswordStatus,
    showPassword,
    handleShowPassword,
    setForgotPasswordStatus,
    handleForgotPassword,
  };
};

export default useAuth;
